import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, ProgressSpinnerModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  @Input() type: 'fullscreen' | 'inline' | 'card' = 'inline';
  @Input() message: string = 'Loading...';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() ariaLabel: string = 'Loading';

  get spinnerStyle(): any {
    const sizes = {
      small: { width: '24px', height: '24px' },
      medium: { width: '32px', height: '32px' },
      large: { width: '48px', height: '48px' }
    };
    
    return sizes[this.size];
  }

  get messageTextClass(): string {
    const sizeClasses = {
      small: 'text-xs',
      medium: 'text-sm',
      large: 'text-base'
    };
    
    return sizeClasses[this.size];
  }
}
